import Vue from 'vue'

import VeeValidate, { Validator } from 'vee-validate';
import fr from 'vee-validate/dist/locale/fr';
import { isValidNumber } from 'libphonenumber-js';

import veeCustom from '../lang/veeCustom';
import { validateStatusEmail } from '@/backend/users'

Validator.localize('fr', fr);

const dictionary = Validator.dictionary
Validator.extend('phone', {
  getMessage(field) {
    return dictionary.getMessage(Validator.locale, 'mobile_phone')
  },
  validate(value) {
    return isValidNumber(value, 'FR')
  }
});

Validator.extend('affiliated', {
  getMessage(field) {
    return dictionary.getMessage(Validator.locale, 'affiliated_service')
  },
  validate(value, args) {
    return args == 'true'
  }
});

Validator.extend('email-available', {
  getMessage(field) {
    return dictionary.getMessage(Validator.locale, 'email_taken')
  },
  validate: async function(email, authorizedEmails) {
    if (authorizedEmails.includes(email)) return true;

    try {
      let { data } = await validateStatusEmail(email)
      return data === null
    } catch(error) {
      return true
    }
  }
});

Vue.use(VeeValidate, { dictionary: veeCustom });



// WEBPACK FOOTER //
// ./src/validators/index.js